export default __webpack_public_path__ + "static/media/MP0055.3622f1be.jpg";